import { render, staticRenderFns } from "./EditSetupDetail.vue?vue&type=template&id=03f503c5&scoped=true&"
import script from "./EditSetupDetail.vue?vue&type=script&lang=js&"
export * from "./EditSetupDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditSetupDetail.vue?vue&type=style&index=0&id=03f503c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f503c5",
  null
  
)

export default component.exports